/* Home shelves: protect the hero, prepare the first shelf, then load near the viewport. */
(function () {
  'use strict';
  if (document.__scHomeShelves) return;
  document.__scHomeShelves = true;
  var cache = new Map(), queue = [], running = 0, ttl = 300000, ready = false;
  function drain() {
    while (running < 2 && queue.length) {
      running++;
      queue.shift()().finally(function () { running--; drain(); });
    }
  }
  function request(url) {
    var previous = cache.get(url);
    if (previous && Date.now() - previous.time < ttl) return previous.promise;
    var entry = {time:Date.now()};
    entry.promise = new Promise(function(resolve, reject) {
      queue.push(async function () {
        var controller = new AbortController();
        var timeout = setTimeout(function () { controller.abort(); }, 15000);
        try {
          var response = await fetch(url, {credentials:'same-origin', signal:controller.signal, headers:{Accept:'text/html'}});
          if (!response.ok) throw Error('Shelf HTTP ' + response.status);
          var documentResult = new DOMParser().parseFromString(await response.text(), 'text/html');
          var result = documentResult.querySelector('[data-home-shelf-result]');
          var source = new URL(url);
          if (!result || 'sc-home-' + result.dataset.mode !== source.searchParams.get('view') ||
              source.pathname.split('/').pop() !== result.dataset.collection) throw Error('Invalid shelf response');
          resolve(Array.from(result.children).filter(function (node) { return node.matches('.home-v2-card'); }).map(function (node) { return node.outerHTML; }).join(''));
        } catch (error) {
          cache.delete(url); reject(error);
        } finally { clearTimeout(timeout); }
      });
      drain();
    });
    cache.set(url, entry);
    return entry.promise;
  }
  // Keep the preload window bounded; hidden tabs never enter the queue.
  function lookAhead() { return Math.min(1600, Math.max(800, innerHeight * 1.5)); }
  function prepareImages(cards) {
    var firstRow = matchMedia('(min-width: 1200px)').matches ? 4 :
      matchMedia('(min-width: 768px)').matches ? 3 : 2;
    cards.forEach(function (card, index) {
      var primary = card.querySelector('img.primary');
      if (primary) {
        primary.loading = index < firstRow ? 'eager' : 'lazy';
        primary.fetchPriority = 'auto';
      }
      // Hover imagery is useful only on pointer devices. The inline fallback
      // avoids downloading even a 1px Shopify image on touch-only screens.
      var hover = card.querySelector('img.hover');
      if (hover && !hover.closest('picture')) {
        var picture = document.createElement('picture');
        var source = document.createElement('source');
        source.media = '(hover: hover) and (pointer: fine)';
        source.srcset = hover.getAttribute('srcset') || hover.getAttribute('src');
        if (hover.hasAttribute('sizes')) source.sizes = hover.getAttribute('sizes');
        hover.removeAttribute('srcset');
        hover.src = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
        hover.loading = 'lazy';
        hover.fetchPriority = 'low';
        hover.replaceWith(picture);
        picture.append(source, hover);
      }
    });
  }
  function visible(slot) { return !slot.closest('[hidden]') && slot.isConnected; }
  function removeEmpty(slot) {
    var section = slot.closest('[data-deferred-home-section]');
    var panel = slot.closest('[data-tabs-shelf-panel]');
    if (!panel) { section.remove(); return; }
    var tab = document.getElementById(panel.getAttribute('aria-labelledby'));
    var wasSelected = tab && tab.getAttribute('aria-selected') === 'true';
    if (tab) tab.remove();
    panel.remove();
    var next = section.querySelector('[data-tabs-shelf-tab]');
    if (!next) section.remove();
    else if (wasSelected) next.click();
  }
  async function load(slot) {
    if (!ready || !visible(slot) || slot.dataset.state === 'loading') return;
    if (slot.dataset.state === 'loaded' && Date.now() - Number(slot.dataset.loadedAt) < ttl) return;
    slot.dataset.state = 'loading';
    slot.setAttribute('aria-busy', 'true');
    var status = slot.querySelector('[data-home-shelf-status]');
    var recovery = slot.querySelector('[data-home-shelf-error]');
    status.hidden = false; recovery.hidden = true;
    try {
      var url = new URL(slot.dataset.source, location.origin);
      if (url.origin !== location.origin) throw Error('Invalid shelf origin');
      var html = await request(url.href);
      if (!slot.isConnected) return;
      var grid = slot.querySelector('[data-home-shelf-content]');
      var parsed = document.createElement('template');
      parsed.innerHTML = html;
      var cards = Array.from(parsed.content.children).slice(0, Number(slot.dataset.limit));
      if (!cards.length) { removeEmpty(slot); return; }
      prepareImages(cards);
      grid.replaceChildren.apply(grid, cards);
      grid.removeAttribute('aria-hidden');
      slot.dataset.state = 'loaded'; slot.dataset.loadedAt = String(Date.now());
      slot.dispatchEvent(new CustomEvent('sc:home-shelf-loaded', {bubbles:true}));
    } catch (error) {
      slot.dataset.state = 'error'; recovery.hidden = false;
    } finally { status.hidden = true; slot.setAttribute('aria-busy', 'false'); }
  }
  function nearby(slot) {
    if (!visible(slot) || slot.dataset.state === 'error') return;
    var box = slot.getBoundingClientRect();
    if (box.top < innerHeight + lookAhead() && box.bottom > -200) load(slot);
  }
  function init() {
    var slots = Array.from(document.querySelectorAll('[data-home-shelf]'));
    if (!slots.length) return;
    function start() {
      if (ready) return;
      ready = true;
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function(entry) { if (entry.isIntersecting) nearby(entry.target); });
        }, {rootMargin:'200px 0px ' + lookAhead() + 'px'});
        slots.forEach(function(slot) { observer.observe(slot); });
      } else {
        var pending = false;
        addEventListener('scroll', function () {
          if (pending) return;
          pending = true;
          requestAnimationFrame(function () { pending = false; slots.forEach(nearby); });
        }, {passive:true});
      }
      var first = slots.find(visible);
      if (first) load(first);
      slots.forEach(nearby);
    }
    document.addEventListener('sc:home-tab-change', function(event) {
      event.target.querySelectorAll('[data-home-shelf]').forEach(function(slot) { if (visible(slot)) load(slot); });
    });
    document.addEventListener('click', function(event) {
      var retry = event.target.closest('[data-home-shelf-retry]');
      if (retry) load(retry.closest('[data-home-shelf]'));
    });
    addEventListener('pageshow', function(event) { if (event.persisted) slots.forEach(nearby); });
    addEventListener('resize', function() { slots.forEach(nearby); }, {passive:true});
    var hero = document.querySelector('.banner--home-hero img');
    if (hero && !hero.complete) {
      hero.addEventListener('load', function () { requestAnimationFrame(start); }, {once:true});
      hero.addEventListener('error', start, {once:true});
      // Let the banner finish before speculative shelf work on slow networks.
      // Scrolling expresses an immediate need for the content below it.
      addEventListener('scroll', start, {once:true, passive:true});
      setTimeout(start, 10000);
    } else requestAnimationFrame(start);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
